import React, { useState }  from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import './admin.css';
import Logo from '../../../assets/Admin_Portal/images/admin_logo.png'
import mailIcon from '../../../assets/Admin_Portal/images/mail-icon.png'
import pwrdIcon from '../../../assets/Admin_Portal/images/pwrd_icon.png'
import { Link, useNavigate } from 'react-router-dom';

import { useForm } from "react-hook-form";
import { useAdminLoginMutation } from '../../../features/AdminFeatures/LoginSlice/LoginApiSlice';
import Swal from "sweetalert2";
import Loader from '../../../components/Loader/Loader';

const AdminLogin = () => {
  const [loginData] = useAdminLoginMutation()
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const { register, handleSubmit, formState: { errors }, reset } = useForm()


  const onSubmit = async (data) => {
    setLoading(true)
    try {
      // console.log("data", data)
      const login = await loginData(data)
      // console.log("login", login)
      navigate('/adminDashboard')
      if (login?.data?.status === 200) {
        localStorage.setItem("token", login?.data?.data?.token)
        localStorage.setItem("email", login?.data?.data?.email)
        localStorage.setItem("userName", login?.data?.data?.userName)
        navigate('/adminDashboard')
        Swal.fire({  
          title: 'Success',  
          type: 'success',  
          text: login?.data?.message,  
        });  
      }
      else{
        Swal.fire({  
          title: 'warning',  
          type: 'warning',  
          text: login?.data?.message,  
        });  
      }
    } catch (err) {
      Swal.fire({
        title: 'Error',
        type: 'Error',
        text: 'something went wrong ! try again',
      });
    }
    setLoading(false)
  }

  return (
    <>
      <div className='admin_login'>
      {loading && <Loader />}
        <Container fluid className='h-100'>
          <Row className='h-100'>
            <Col xs={3} className='h-100 position-relative text-center'>
              <img src={Logo} alt="logo" className='adminLogo' />



            </Col>

            <Col xs={9} className='admin_Bg h-100'>
              <div className='adminForm'>


                <form onSubmit={handleSubmit(onSubmit)} className="form-md">
                  <h4 className='welcomeText'>Welcome Back!</h4>
                  <p className='adminPara text-center'>Please Signin to continue</p>
                  <div className="form-group">
                    <input
                      id="email"
                      {...register("email", {
                        required: "*required",
                        pattern: {
                          value: /\S+@\S+\.\S+/,
                          message: "Entered value does not match email format",
                        },
                      })}
                      type="text"
                      placeholder='username/email'
                    />
                    <span className='inputIcon'>
                      <img src={mailIcon} alt="Mail" />
                    </span>
                    {/* <label className='customLabel' htmlFor="email">email</label> */}
                    {errors.email && <span role="alert">{errors.email.message}</span>}
                  </div>
                  <div className="form-group">

                    <input
                      id="password"
                      {...register("password", {
                        required: "*required",
                        minLength: {
                          value: 5,
                          message: "min length is 5",
                        },
                      })}
                      type="password"
                      placeholder='Password'
                    />
                    <span className='inputIcon'>
                      <img src={pwrdIcon} alt="Mail" />

                    </span>
                    {/* <label className='customLabel' htmlFor="password">password</label> */}
                    {errors.password && <span role="alert">{errors.password.message}</span>}
                  </div>
                  <div className='d-flex align-item-center justify-content-between mb-3'>
                    <div class="form-check">
                      <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                      <label className="form-check-label" for="flexCheckDefault">
                        Remember me
                      </label>
                    </div>

                    <Link to="">Forgot Password?</Link>
                  </div>

                  <button className='btn btnSubmit' type="submit">LOGIN</button>


                </form>

              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}

export default AdminLogin;
